export default __webpack_public_path__ + "85ad9e0cc9fdcd3dad73c7f559010c94.jpg";